import React, { memo } from 'react';
import { SearchFilters, SearchItemsByFiltersResult } from 'src/services/search';
import { GridResultSectionRender } from 'src/modules/materials/components/ShowcasePage/renderers/GridResultSectionRender';

export const SearchResultsContainer = memo<{
  heading?: string;
  filters: SearchFilters;
  results: SearchItemsByFiltersResult | undefined;
}>(function SearchResultsContainer({ heading, filters, results }) {
  return (
    <GridResultSectionRender
      section={{
        name: heading ?? (filters.q ? String(filters.q) : 'Results'),
        count: Number(results?.count) < 0 ? 0 : results?.count,
      }}
      items={results?.items}
    />
  );
});
